<script>
  import {mapActions, mapGetters} from 'vuex';
  import modulesUtils from "../ModulesUtils";

  import utils from "../../utils";

  export default {
    components: {
    },
    data () {
      return {
        filter: {},
        checked: true
      }
    },
    computed: {
      ...mapGetters({
        list: 'modulesList'
      }),
    },
    methods: {
      ...mapActions([
        'modulesDoSearch'
      ]),
      getLogo() {
        return modulesUtils.apiUrl() + '/f/systemBackground/' + this.$route.params.systemId
      }
    },
    mounted () {
      utils.addBackground(this.getLogo());
      this.modulesDoSearch(this.$route.params);
    },
    destroyed () {
      utils.removeBackground();
    }
  }
</script>

<template>
  <div>
  </div>
</template>



// WEBPACK FOOTER //
// ModulesList.vue?1cdae458